import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResultsPageComponent } from './results-page.component';
import { ResultsListComponent } from './results-list/results-list.component';
import { SkuSetOptionsComponent } from './sku-set-options/sku-set-options.component';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { SkuSearchUiModule } from '@emi/sku-search/ui';
import { SortingOptionsComponent } from './sorting-options/sorting-options.component';
import { MatSelectModule } from '@angular/material/select';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedUiModule } from '@emi/shared/ui';
import { SharedStateSkuSearchModule } from '@emi/shared/state/sku-search';
import { FiltersModule } from '@emi/shared/feature/filters';
import { SearchFilterSummaryComponent } from './search-filter-summary/search-filter-summary.component';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        MatTabsModule,
        SkuSearchUiModule,
        MatCheckboxModule,
        MatIconModule,
        MatSelectModule,
        InfiniteScrollModule,
        FormsModule,
        MatFormFieldModule,
        MatTooltipModule,
        SharedUiModule,
        SharedStateSkuSearchModule,
        FiltersModule,
    ],
    declarations: [
        ResultsPageComponent,
        ResultsListComponent,
        SkuSetOptionsComponent,
        ResultsPageComponent,
        SortingOptionsComponent,
        SearchFilterSummaryComponent,
    ],
    exports: [ResultsPageComponent, ResultsListComponent, SkuSetOptionsComponent, SortingOptionsComponent, SearchFilterSummaryComponent],
})
export class SkuSearchFeatureResultsPageModule {}
